import { UseCaseError } from '../../../core/errors/UseCaseError';

export class AcceptFollowRequest {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  async execute(currentUserId, requesterId) {
    try {
      if (!currentUserId || !requesterId) {
        throw new UseCaseError('Les IDs des utilisateurs sont requis');
      }

      await this.userRepository.acceptFollowRequest(currentUserId, requesterId);
      console.log(`Demande d'abonnement acceptée de ${requesterId} par ${currentUserId}`);
      return true;
    } catch (error) {
      console.error('Erreur dans AcceptFollowRequest UseCase:', error);
      throw error;
    }
  }
} 